import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import React from "react";

const AccountTypeDetails = ({
  selectedType = {},
  setSelectedType = () => {},
  verifying = false,
  createAddressSubmitHandler = () => {},
  getStates = () => {},
  stateList = [],
}) => {
  const [address, setAddress] = React.useState({
    address1: "",
    address2: "",
    landmark: "",
    city: "",
    state: "",
    pincode: "",
  });
  const [error, setError] = React.useState({
    address1: false,
    address2: false,
    landmark: false,
    city: false,
    state: false,
    pincode: false,
  });
  return (
    <>
      <div style={{ padding: "1.5rem" }}>
        <span style={{ fontSize: "26px", color: "#CFCFCF" }}>
          <p style={{ textAlign: "center" }}>
            {" "}
            Please fill the {selectedType?.admin_type_name} details
          </p>
        </span>
        {selectedType?.admin_type_id === 3 && (
          <>
            <TextField
              className="form-input"
              label="House No./ Building name"
              value={address.address1}
              onChange={(e) => {
                setError({ ...error, address1: e.target.value ? false : true });
                setAddress({ ...address, address1: e.target.value });
              }}
              error={error.address1}
              helperText={
                error.address1 ? "Please enter house no. / Building name" : " "
              }
              disabled={verifying}
              style={{ margin: "0.5rem 0rem" }}
              placeholder="Ex. Abc Xyz"
              fullWidth
            />
            <TextField
              className="form-input"
              label="Street/Area"
              value={address.address2}
              onChange={(e) => {
                setError({ ...error, address2: e.target.value ? false : true });
                setAddress({ ...address, address2: e.target.value });
              }}
              error={error.address2}
              helperText={error.address2 ? "Please enter street / Area" : " "}
              disabled={verifying}
              style={{ margin: "0.5rem 0rem" }}
              placeholder="Ex. Abc Xyz"
              fullWidth
            />
            <TextField
              className="form-input"
              label="Nearby landmark"
              value={address.landmark}
              onChange={(e) => {
                setError({ ...error, landmark: e.target.value ? false : true });
                setAddress({ ...address, landmark: e.target.value });
              }}
              error={error.landmark}
              helperText={error.landmark ? "Please enter nearby landmark" : " "}
              disabled={verifying}
              style={{ margin: "0.5rem 0rem" }}
              placeholder="Ex. Abc Xyz"
              fullWidth
            />
            <TextField
              className="form-input"
              label="City"
              value={address.city}
              onChange={(e) => {
                setError({ ...error, city: e.target.value ? false : true });
                setAddress({ ...address, city: e.target.value });
              }}
              error={error.city}
              helperText={error.city ? "Please enter city name" : " "}
              disabled={verifying}
              style={{ margin: "0.5rem 0rem" }}
              placeholder="Ex. Abc Xyz"
              fullWidth
            />
            <FormControl sx={{ width: "100%" }}>
              <InputLabel id="label" style={{ color: "#bdbfc1" }}>
                Select State
              </InputLabel>
              <Select
                className="form-input"
                style={{
                  borderRadius: "10px",
                  overflow: "hidden",
                  background: "#242424",
                }}
                variant="outlined"
                value={address.state}
                onChange={(e) => {
                  setError({ ...error, state: e.target.value ? false : true });
                  setAddress({ ...address, state: e.target.value });
                }}
                fullWidth
                label="Select State"
              >
                <MenuItem value="">Select State</MenuItem>
                {stateList.map((state, i) => {
                  return (
                    <MenuItem value={state.state_id} key={i}>
                      {state.state}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
            <TextField
              className="form-input"
              label="Pin Code"
              value={address.pincode}
              onChange={(e) => {
                setError({ ...error, pincode: e.target.value ? false : true });
                setAddress({ ...address, pincode: e.target.value });
              }}
              error={error.pincode}
              helperText={error.pincode ? "Please enter pincode" : " "}
              disabled={verifying}
              style={{ margin: "1.5rem 0rem", width: "50%" }}
              placeholder="Ex. 400001"
              inputProps={{ maxLength: 6 }}
            />
          </>
        )}
      </div>
      <div className="request-footer-btn">
        <Button
          id="step-5-onboarding"
          disabled={
            verifying ||
            address.address1 === "" ||
            address.address2 === "" ||
            address.landmark === "" ||
            address.city === "" ||
            address.state === "" ||
            address.pincode === ""
          }
          onClick={() => createAddressSubmitHandler(address)}
          fullWidth
          variant="contained"
          size="large"
          style={{
            padding: "16px 0",
            fontSize: "1em",

            background:
              verifying ||
              address.address1 === "" ||
              address.address2 === "" ||
              address.landmark === "" ||
              address.city === "" ||
              address.state === "" ||
              address.pincode === ""
                ? "#383838"
                : "linear-gradient(91.75deg, #FFFFFF 0.11%, #C4C4C4 100.1%)",
            color:
              verifying ||
              address.address1 === "" ||
              address.address2 === "" ||
              address.landmark === "" ||
              address.city === "" ||
              address.state === "" ||
              address.pincode === ""
                ? "#232323"
                : "#FF4A01",
          }}
        >
          {verifying ? "Submitting..." : "Continue"}
        </Button>
      </div>
    </>
  );
};

export default AccountTypeDetails;
